import { gql } from '@/shared/graphql/generated/cache';

export const getAllLpLoanAccountsQuery = gql(/* GraphQL */ `
  query GetAllLpLoanAccounts($asset: ChainflipAsset, $idSs58: String) {
    loanAccounts: allLpLoanAccounts(filter: { lpIdSs58: { equalTo: $idSs58 } }) {
      nodes {
        lpIdSs58
        borrowPowerUsedBps
        loanToValueBps
        totalBorrowAmountUsd
        totalCollateralBalanceUsd
        collateralBalances: lpCollateralBalancesByLoanAccountLpIdSs58 {
          nodes {
            amountUsd
            amount
            asset
          }
        }
        loans: loansByLoanAccountLpIdSs58(filter: { asset: { equalTo: $asset } }) {
          nodes {
            id
            lp: lpLoanAccountByLoanAccountLpIdSs58 {
              lpIdSs58
            }
            asset
            principalAmount
            principalAmountUsd
            status
          }
        }
      }
    }
  }
`);

export const getLendingGlobalConfigQuery = gql(/* GraphQL */ `
  query GetLendingGlobalConfig {
    config: lendingGlobalConfigById(id: 1) {
      targetLtvThresholdBps
      softLiquidationLtvThresholdBps
      minLoanUpdateAmountUsd
      minLoanRequestAmountUsd
      lowLtvPenaltyMaxLtvBps
      lowLtvPenaltyBpsAtMaxLtv
      minSupplyAmountUsd
      interestFeeNetworkShareBps
    }
  }
`);

export const getAllLpLendingPositionsQuery = gql(/* GraphQL */ `
  query GetAllLpLendingBalances($asset: ChainflipAsset, $idSs58: String) {
    lpPositions: allLpLendingBalances(
      filter: { asset: { equalTo: $asset }, lpIdSs58: { equalTo: $idSs58 } }
    ) {
      nodes {
        lpIdSs58
        asset
        totalAmount
        totalAmountUsd
        totalAvailableAmount
        totalAvailableAmountUsd
        poolSharePercent
      }
    }
  }
`);

export const getAllLpCollateralBalancesQuery = gql(/* GraphQL */ `
  query GetAllLpCollateralBalances($asset: ChainflipAsset, $idSs58: String) {
    collateralBalances: allLpCollateralBalances(
      filter: { asset: { equalTo: $asset }, loanAccountLpIdSs58: { equalTo: $idSs58 } }
    ) {
      agg: aggregates {
        sum {
          amountUsd
        }
      }
    }
  }
`);

export const getAllLendingPoolsQuery = gql(/* GraphQL */ `
  query GetAllLendingPools($asset: ChainflipAsset) {
    lendingPools: allLendingPools(filter: { asset: { equalTo: $asset } }) {
      nodes {
        ...LendingPoolInfo
      }
    }
  }
`);

export const getActiveBoostLoans = gql(/* GraphQL */ `
  query GetActiveBoostLoans {
    loans: allLoans(filter: { borrowerType: { equalTo: SYSTEM_BOOST }, asset: { equalTo: Btc } }) {
      aggregates {
        sum {
          principalAmount
        }
      }
    }
  }
`);

gql(`
  fragment LendingPoolInfo on LendingPool {
    asset
    totalAmount
    totalAmountUsd
    totalAvailableAmount
    totalAvailableAmountUsd
    totalBorrowedAmount
    totalBorrowedAmountUsd
    interestRateBps
    utilisationRateBps
    utilisationCapBps
    originationFeeBps
    liquidationFeeBps
    interestAtZeroUtilisationBps
    junctionUtilisationBps
    interestAtJunctionBps
    interestAtMaxUtilisationBps
  }
`);
